import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ChangeElementTypologyDialog,
  FormSubmitButtons,
  InfoWrapper,
  RHFSelect,
  RHFTagAutocomplete,
} from 'components';
import {
  appoggiAntisismiciAppoggiOption,
  tipologiaAppoggioOptions,
} from 'constants/selectOptions';
import { INFO } from 'pages/Inspections/config/info';
import { resetObjectSchedaIspezione } from 'utils/Inspections/L1/resetSchedaIspezione';
import useSchedaDifetti from 'utils/Inspections/L1/schedeDifetti';
import { isNullOrUndefinedOrEmptyString } from 'utils/utilities';
import { GridWrap } from '../Accordion4Connections.styles';

const AppoggiForm = ({
  appoggiFields,
  selected,
  setSelected,
  appoggiTable,
  selectedIdx,
}) => {
  const { getValues, setValue } = useFormContext({
    defaultValues: {
      l0t2a4_appoggiTableValue: [],
      l0t2a4_tipologiaAppoggioTableValue: '',
      l0t2a4_appoggiAntisismiciTableValue: '',
    },
  });

  const { populateSchedaDifetti } = useSchedaDifetti();

  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  useEffect(() => {
    setValue('l0t2a4_appoggiTableValue', selected);
  }, [selected]);

  useEffect(() => {
    onResetAppoggi();
  }, [selectedIdx]);

  const changeAutocomplete = value => {
    setSelected(value);
  };

  const changeAppoggi = () => {
    const l0t2a4_tipologiaAppoggioTableValue = getValues(
      'l0t2a4_tipologiaAppoggioTableValue'
    );
    const l0t2a4_appoggiAntisismiciTableValue = getValues(
      'l0t2a4_appoggiAntisismiciTableValue'
    );

    const ids = selected.map(el => el.codice);

    const appoggi = [...appoggiFields];

    appoggi.map((x, index) => {
      if (ids.includes(x?.codice)) {
        appoggi[index] = {
          ...x,
          tipologiaAppoggio: l0t2a4_tipologiaAppoggioTableValue,
          appoggiAntisismici: l0t2a4_appoggiAntisismiciTableValue,
          ...(l0t2a4_tipologiaAppoggioTableValue !== x.tipologiaAppoggio
            ? {
                ...resetObjectSchedaIspezione,
                schedaDifetti: populateSchedaDifetti(
                  'appoggio',
                  l0t2a4_tipologiaAppoggioTableValue
                ).map(el => {
                  return {
                    ...el,
                    visto: false,
                    statoDifetto: '',
                    estensioneDifetto: '',
                    intensitaDifetto: '',
                    ps: false,
                    note: '',
                    media: [],
                  };
                }),
              }
            : null),
        };
      }
    });

    setValue(appoggiTable, appoggi);
    onResetAppoggi();
  };

  const onConfirmChangeAppoggi = () => {
    setOpenConfirmationDialog(false);
    changeAppoggi();
  };

  const onSubmitAppoggi = () => {
    const l0t2a4_tipologiaAppoggioTableValue = getValues(
      'l0t2a4_tipologiaAppoggioTableValue'
    );

    const ids = selected.map(el => el.codice);

    const appoggi = [...appoggiFields];

    const hasChangedTipologia = appoggi.some(el => {
      if (ids.includes(el?.codice)) {
        return (
          l0t2a4_tipologiaAppoggioTableValue !== el.tipologiaAppoggio &&
          !isNullOrUndefinedOrEmptyString(el.tipologiaAppoggio)
        );
      }
    });

    if (hasChangedTipologia) {
      setOpenConfirmationDialog(true);
    } else {
      changeAppoggi();
    }
  };

  const onResetAppoggi = () => {
    setValue('l0t2a4_appoggiTableValue', []);
    setValue('l0t2a4_tipologiaAppoggioTableValue', '');
    setValue('l0t2a4_appoggiAntisismiciTableValue', '');

    setSelected([]);
  };

  return (
    <>
      <GridWrap container spacing={2} mt={2}>
        <InfoWrapper size={5} infoMessage={INFO.appoggiSelezionati.infoMessage}>
          <RHFTagAutocomplete
            multiple={true}
            id="tags-appoggi"
            name={'l0t2a4_appoggiTableValue'}
            changeAutocomplete={value => {
              changeAutocomplete(value);
            }}
            labelName={'option.codice'}
            getOptionLabel={option => option.codice}
            opt={appoggiFields?.filter(
              el => !selected?.some(s => s?.id === el?.id)
            )}
            label="Appoggi selezionati"
          />
        </InfoWrapper>
        <GridWrap item xs={3}>
          <RHFSelect
            name="l0t2a4_tipologiaAppoggioTableValue"
            label="Tipologia Appoggio*"
            defaultValue={''}
            onChange={e => {
              setValue('l0t2a4_tipologiaAppoggioTableValue', e.target.value);
            }}
            selectOptions={tipologiaAppoggioOptions}
          />
        </GridWrap>
        <GridWrap item xs={3}>
          <RHFSelect
            name="l0t2a4_appoggiAntisismiciTableValue"
            label="Appoggi Antisismici"
            defaultValue={''}
            onChange={e => {
              setValue('l0t2a4_appoggiAntisismiciTableValue', e.target.value);
            }}
            selectOptions={appoggiAntisismiciAppoggiOption}
          />
        </GridWrap>
        <GridWrap item xs={1}>
          <FormSubmitButtons
            onSubmit={onSubmitAppoggi}
            onReset={onResetAppoggi}
          />
        </GridWrap>
      </GridWrap>
      <ChangeElementTypologyDialog
        open={openConfirmationDialog}
        onClose={() => setOpenConfirmationDialog(false)}
        onConfirm={onConfirmChangeAppoggi}
      />
    </>
  );
};

AppoggiForm.propTypes = {
  appoggiFields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      tipologiaAppoggio: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      appoggiAntisismici: PropTypes.string,
    })
  ),
  selected: PropTypes.array,
  setSelected: PropTypes.func,
  appoggiTable: PropTypes.string,
  selectedIdx: PropTypes.number,
};
export default AppoggiForm;
